import React from 'react';

import useConfiguratorData from '../../hooks/useConfiguratorData';
import useLeadData from '../../hooks/useLeadData';

const ColorSelector = () => {

    const {getColors, getSelectedColor, setSelectedColor} = useConfiguratorData();
    const { updateLead } = useLeadData();

    const colors = getColors();
    const selectedColor = getSelectedColor();

    const handleColorChange = color => {
        setSelectedColor(color);
        updateLead([{name: 'color', value: color.name}])
    }

    return (
        <div className="colors-container">
            {selectedColor ? 
            <>
                <div className="component-header">
                    <h2>Elige un color</h2>
                </div>
                <div className="colors">
                    {colors.map(color => (
                        <div className="color-item" key={`color-${color.id}`}>
                            <button className={selectedColor.id === color.id ? "active" : ""} onClick={() => handleColorChange(color)}>
                                <span className="circle" style={{backgroundColor: color.hexcode}}></span>
                            </button>
                            <small>{color.name}</small>
                        </div>
                    ))}
                </div>
                {selectedColor.disclaimer && <div className="component-legals">{selectedColor.disclaimer}</div>}
            </>
            : null}
        </div>
    )
}

export default ColorSelector;